import { render, staticRenderFns } from "./OzBaseButton.vue?vue&type=template&id=37a4e52a&"
import script from "./OzBaseButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzBaseButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports